define('infoArchitecture/qmRoutes',[
    'lib/base64',
    'lib/knockout',
    'lib/lodash4',
    'infoArchitecture/siteMap',
    'services/navHelper',
    'viewModels/appView'
], function (base64, ko, _, siteMap, navHelper, appView) {
    'use strict';

    var options = {
        admin: {
            playbackContext: "admin"
        },
        agent: {
            playbackContext: "agent"
        }
    };

    function activateSubViewIfNeeded(parentView, subViewName) {
        return parentView.subViews.getActiveView() === subViewName ?
            parentView.subViews[subViewName]() :
            parentView.subViews.setActiveView(subViewName);
    }

    function activatePlaybackViewIfNeeded(appMain, conversationId, playbackViewOptions) {
        var interactionsMain = _.reduce([
            'appMain',
            'privilegedView',
            'interactionsMain'
        ], activateSubViewIfNeeded, appView);

        // If the already activated view is for this same conversationId, just return the existing one
        if (interactionsMain.subViews.getActiveView() === 'playbackView') {
            var playbackView = interactionsMain.subViews.playbackView();
            if (ko.unwrap(playbackView.conversationId) === conversationId) {
                return playbackView;
            }
        }

        // In all other cases, activate one for this conversationId
        return interactionsMain.subViews.setActiveView('playbackView', conversationId, playbackViewOptions);
    }

    var qmRoutes = {
        // Interactions Search
        '#admin/interactions/search': {
            handler: function () {
                appView
                    .subViews.setActiveView('appMain')
                    .subViews.setActiveView('privilegedView')
                    .subViews.setActiveView('interactionsMain')
                    .subViews.setActiveView('interactionsSearchTabsView')
                    .subViews.setActiveView('searchResultsView');
            },
            pageInfo: siteMap.interactionsList,
            fixedHeight: true
        },

        // Interaction Details
        '#admin/interactions/:conversationId': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateConversationDetailsTab();
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/evaluations/new': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateConversationDetailsTab();
                view.activateCreateEvaluationTab();
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/audit': {
            handler: function(ctx){
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateAuditTab();
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#agent/interactions/:conversationId/timeline': {
            handler: function(ctx){
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateTimelineTab();
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/timeline': {
            handler: function(ctx){
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateTimelineTab();
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/evaluations/:assignedEvaluationId': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateConversationDetailsTab();
                view.activateAssignedEvaluationTab(ctx.params.assignedEvaluationId, true);
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/calibrations/:calibrationId': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateCalibrationTab(ctx.params.calibrationId, true);
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/surveys/:surveyId': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateSurveyTab(ctx.params.surveyId, true, true);
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/evaluationSummary': {
            handler: function (ctx) {
                navHelper.redirectTo("#admin/interactions/" + ctx.params.conversationId + "/qualitySummary");
            }
        },

        '#admin/interactions/:conversationId/qualitySummary': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateConversationDetailsTab();
                view.activateQualitySummaryTab(ctx.params.conversationId, true);
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/journeys': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateCustomerJourneyTab();
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#admin/interactions/:conversationId/journeys/:sessionId': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.admin);
                view.activateCustomerJourneyTab(ctx.params.sessionId);
            },
            pageInfo: siteMap.interactionsList.interactionDetails
        },

        '#agent/interactions/:conversationId': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.agent);
                view.activateConversationDetailsTab();
            },
            pageInfo: siteMap.dashboard.interactionDetails
        },

        '#agent/interactions/:conversationId/evaluations/:assignedEvaluationId': {
            handler: function (ctx) {
                var view = activatePlaybackViewIfNeeded(appView, ctx.params.conversationId, options.agent);
                view.activateConversationDetailsTab();
                view.activateAssignedEvaluationTab(ctx.params.assignedEvaluationId, false);
            },
            pageInfo: siteMap.dashboard.interactionDetails
        },

        // Interactions List
        '#admin/interactions': {
            handler: function () {
                navHelper.redirectTo("admin/interactions/search");
            }
        }
    };

    return qmRoutes;
});

